import { createAsyncThunk } from '@reduxjs/toolkit';

import { setNavItem, setNavReady } from '../init';

export const changeRound = createAsyncThunk(
    'nav/changeRound',
    async ({ round, season }, { dispatch, getState }) => {
        setNavReady(false);

        // If initial round hasn't been set in the store, set it now.
        const state = getState().competitionNavV2;

        if (!state.round.initialItemId) {
            dispatch(
                setNavItem({
                    navItem: 'round',
                    value: {
                        ...round,
                        initialItemId: round.id
                    }
                })
            );
        } else {
            dispatch(
                setNavItem({
                    navItem: 'round',
                    value: round
                })
            );
        }

        // If season has changed, trigger ready when new round matches
        // season we have changed to.
        if (season) {
            if (season.id === round.seasonId) {
                dispatch(setNavReady(true));
            }
        } else {
            dispatch(setNavReady(true));
        }
    }
);
